export enum CreatorSortField {
	name = 'normalizedUsername',
	createdAt = 'createdAt',
	puzzles = 'Puzzles',
	followers = 'Followers',
}
